// src/pages/VerifyEmail.jsx
import React, { useEffect } from "react";
import "./verifyemail.css";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { verifyEmailApi } from "../../redux/apiCalls/authApiCall";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const {user , isEmailVerified} = useSelector ((state) => state.auth)
  const dispatch = useDispatch()
  
  const {userId , token} = useParams()

  const handleResend = () => {
    // later we will connect this to backend API
    alert("Verification email sent again!");
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  useEffect(()=>{
    dispatch(verifyEmailApi(userId , token))
  } , [userId , token])

  return (
    <div className="verify-container">
      <div className="verify-card">
        <div className="verify-icon">
          📩
        </div>

        <h2 className="verify-title">Verify Your Email</h2>

        <p className="verify-text">
          We've sent a verification link to your email address.
          <br />
          Please check your inbox and click the link to activate your account.
        </p>

        <div className="verify-buttons">
          <button className="resend-btn" onClick={handleResend}>
            Resend Email
          </button>

          <button className="login-btn" onClick={handleBackToLogin}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
